import React from "react";
import { Box, Typography } from "@material-ui/core";
import clsx from "clsx";
import "./styles.scss";

interface ILoadingTextProps {
  message: string;
  className?: string;
}
const LoadingText = ({ message, className }: ILoadingTextProps) => {
  return (
    <Box className={clsx("loading-text", className)}>
      <Typography
        variant="inherit"
        className={clsx("loading-text-copy", "message")}
      >
        {message}
      </Typography>
      <Typography
        variant="inherit"
        className={clsx("loading-text-copy", "ellipsis")}
      >
        .
      </Typography>
      <Typography
        variant="inherit"
        className={clsx("loading-text-copy", "ellipsis")}
      >
        .
      </Typography>
      <Typography
        variant="inherit"
        className={clsx("loading-text-copy", "ellipsis")}
      >
        .
      </Typography>
    </Box>
  );
};

export default LoadingText;
